import BaseModel from './BaseModel';
import Review from './Review';
import ReviewMember from './ReviewMember';
import { UploadState } from '@/enums';
import { formatDuration, intervalToDuration } from 'date-fns';
import { v4 as createUUID } from 'uuid';

export default class ReferenceFile extends BaseModel {
  constructor(data = {}) {
    super(ReferenceFile, data);
    this.id = data.id;
    this.optimisticId = data.optimisticId;
    this.name = data.name;
    this.uri = data.uri;
    this.invalidUri = data.invalidUri;
    this.uploadGroupId = data.uploadGroupId;
    this.source = data.source;
    this.review = data.review && new Review(data.review);
    this.uploadedBy =
      data.uploadedBy && new ReviewMember(data.uploadedBy);
    this.preScreenedOutcome = data.preScreenedOutcome;
    this.uploadState = data.uploadState;
    this.recordsParsedCount = data.recordsParsedCount;
    this.recordsProcessedCount = data.recordsProcessedCount;
    this.newReferenceCount = data.newReferenceCount;
    this.invalidCount = data.invalidCount;
    this.autoResolvedDuplicateCount = data.autoResolvedDuplicateCount;
    this.identicalDuplicateCount = data.identicalDuplicateCount;
    this.potentialDuplicateCount = data.potentialDuplicateCount;
    this.manualDuplicateCount = data.manualDuplicateCount;
    this.createdAt = data.createdAt && new Date(data.createdAt);
    this.updatedAt = data.updatedAt && new Date(data.updatedAt);
  }

  get key() {
    return this.id || this.optimisticId;
  }

  static optimisticResponse(uri, uploadGroupId) {
    const name = uri.split('/').pop();
    return new ReferenceFile({
      optimisticId: createUUID(),
      name,
      uri,
      uploadGroupId,
      uploadState: UploadState.PENDING,
    });
  }

  inProgress() {
    return !this.isDone();
  }

  failed() {
    return this.isDone() && !this.success();
  }

  success() {
    return this.uploadState === UploadState.COMPLETE;
  }

  isDone() {
    return [
      UploadState.COMPLETE,
      UploadState.EXTRACTING_FAILED,
      UploadState.TIMED_OUT,
      UploadState.ERROR,
    ].includes(this.uploadState);
  }

  durationString() {
    const interval = intervalToDuration({
      start: this.createdAt,
      end: new Date(),
    });
    let format = ['hours', 'minutes', 'seconds'];
    let zero = false;
    if (
      interval.hours === 0 &&
      interval.minutes === 0 &&
      interval.seconds === 0
    ) {
      format = ['seconds'];
      zero = true;
    }
    return formatDuration(interval, {
      format,
      delimiter: ', ',
      zero,
    });
  }
}
